import type { ProductDetails } from "@raumagarn/formatters";
import { useQuery } from "@tanstack/react-query";
import axios from "axios";

const getYarnProduct = async (ids?: (string | undefined)[] | undefined) => {
	const filteredIds = ids?.filter(Boolean);

	if (!filteredIds || filteredIds.length === 0) return [];

	const res = await axios.post<ProductDetails[]>("/api/storefront/product-cards", {
		ids: filteredIds,
	});

	return res.data;
};

export const useYarnProduct = (ids?: (string | undefined)[] | undefined) => {
	const { data } = useQuery({
		queryKey: ["yarn-picker", ids],
		queryFn: () => getYarnProduct(ids),
	});

	if (!data) return [];
	return data;
};
